export default __webpack_public_path__ + "static/media/purpes 4.47598ded.png";